module.exports = __webpack_public_path__ + "static/media/logo.b2df0657.png";